import { BaseGetRequest } from './core/baseGetRequest';
import { AllBrokerDetails, AllBrokerDetailsDynamicType } from 'acscp/api/models/brokerDetails';

export class AllBrokerDetailsRequest extends BaseGetRequest<AllBrokerDetails> {
    constructor() {
        super('broker-details/all', {}, AllBrokerDetailsDynamicType);
    }
}
